__turbopack_context__.v({
  "carouselWrapper": "CatalogueSection-module__Ra_U2q__carouselWrapper",
  "root": "CatalogueSection-module__Ra_U2q__root",
});
